import { ActivatedRoute } from '@angular/router';
import { Hunt } from '@cyborg-monorepo/hunter/common';

import { Injectable, inject } from '@angular/core';
import { HuntStateService } from './hunt-state.service';
import { HuntEditorStoreService } from './huntEditorStoreService';
import { QueryActiveHuntService } from './queryActiveHuntService';
import { QueryActiveHuntPackageService } from './queryActiveHuntPackageService';
import { HuntPackageDetailUiStateService } from '../hunt-package-details/services/HuntPackageDetailUiStateService';
import { QueryActiveHuntPackageQueryService } from './queryActiveHuntPackageQueryService';

import { hydrateFromRoute } from '../helpers/hydrate-from-route';

@Injectable({ providedIn: 'root' })
export class HuntContextService {
  readonly state = inject(HuntStateService);
  readonly editor = inject(HuntEditorStoreService);
  readonly query = inject(QueryActiveHuntService);
  readonly queryPackages = inject(QueryActiveHuntPackageService);
  readonly ui = inject(HuntPackageDetailUiStateService);
  readonly queryLogic = inject(QueryActiveHuntPackageQueryService);

  constructor() {
    const route = inject(ActivatedRoute);

    // ✅ Hydrate the context using resolved hunt
    hydrateFromRoute<Hunt>(route, 'hunt', (data) => {
      if (!this.state.hunt()) {
        console.log('⚡ Hydrating HuntContext from HuntResolver');
        this.state.updateHunt(data);
        this.editor.load(data);
      }
    });

    // ✅ Sync selected package ID from route
    const pkgId = route.snapshot.paramMap.get('packageId');
    if (pkgId) {
      this.editor.setSelectedPackageId(pkgId);
    }
  }
}
